import { ItfProductFloorsBtn, ItfProductFloorsChild, ItfProductFloorsData, ItfProductFloorsItem, ItfProductFloorsLink } from './type';

export const defaultBtn: ItfProductFloorsBtn = {
    type: 'fill',
    text: '',
    url: '',
    color: 'white',
    bgColor: 'black',
};

export const defaultLink: ItfProductFloorsLink = {
    text: '',
    url: '',
};

export const defaultItem: ItfProductFloorsItem = {
    label: '',
    labelColor: '#3F68E0',
    name: '',
    text: '',
    btns: [defaultBtn],
    img: '',
    hoverImg: '',
    hoverImgH5: '',
    btnsType: 'X',
};

export const defaultChild: ItfProductFloorsChild = {
    tab: '',
    label: '',
    labelColor: '#3F68E0',
    name: '',
    nameColor: 'black',
    text: '',
    textColor: '#83868A',
    pc: '',
    h5: '',
    btns: [defaultBtn],
    links: [defaultLink],
    items: [defaultItem],
};

export const configData: ItfProductFloorsData = {
    theme: 'white',
    title: '',
    titleColor: 'black',
    desc: '',
    descColor: '#83868A',
    children: [defaultChild],
};
